import React, { ChangeEvent, FocusEvent, MouseEvent } from 'react'
import { IIshikawaCategory, IIshikawaDiagram } from '../types'
import { CauseBottomDiagonalDot, CauseBottomDiagonalLine, CauseBottomItem, CauseContent, CausesGroup, CauseTopDiagonalDot, CauseTopDiagonalLine, CauseTopItem, ContentCauseRoot } from '../style'
import GetCategory from './GetCategory'
import { GetRootCauses } from './GetRootCause'

interface IGetBottomCausesContent {
  diagram: IIshikawaDiagram
  handleDoubleClick: (event: MouseEvent<HTMLSpanElement>, category: IIshikawaCategory) => void
  handleBlur: (e: FocusEvent<HTMLInputElement>, category: IIshikawaCategory) => void
  handleChange: (e: ChangeEvent<HTMLInputElement>) => void
  handleClickCause: (
      event: MouseEvent<HTMLSpanElement>,
      category: IIshikawaCategory,
      causeIndex: number,
      value: string
  ) => void
}
export default function GetBottomCausesContent({diagram,handleChange,handleClickCause,handleBlur,handleDoubleClick}:IGetBottomCausesContent) {
  const categories = diagram && diagram.categories ?
    diagram.categories.map((category: IIshikawaCategory) =>
      category.title) : []
  const bottomCauses: JSX.Element[] = categories.slice(categories.length / 2)
    .map((category: string, index: number) => {
      let objCategory = diagram && diagram.categories.filter((cat: IIshikawaCategory) =>
        cat.title === category).find((c: IIshikawaCategory) => !!c)
      return (
        <CauseContent
          data-testid="test-bottom-cause-group"
          key={`bottom_causes_${category}_${index}`}>
          <ContentCauseRoot>
            <GetRootCauses
              diagram={diagram}
              category={category}
              handleChange={handleChange}
              handleClickCause={handleClickCause}
            />
            <CauseBottomDiagonalLine>
              <CauseBottomDiagonalDot />
            </CauseBottomDiagonalLine>
          </ContentCauseRoot>
          <CauseBottomItem>
            <GetCategory
              index={index}
              category={objCategory}
              handleBlur={handleBlur}
              handleChange={handleChange}
              handleDoubleClick={handleDoubleClick}
            />
          </CauseBottomItem>
        </CauseContent>
      )
    })

  return <CausesGroup>{bottomCauses}</CausesGroup>
}
